import * as React from 'react';
import { Box, TableRow, Table, TableHead, TableCell, TableBody, styled } from '@mui/material';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';

import FailureScreen from 'src/frontend-common/components/FailureScreen';
import EmptyState from 'src/frontend-common/components/EmptyState';
import { UserDetail } from 'src/dto/User';
import { UserCells } from './UserCells';
import { useGetCurrentUserQuery } from 'src/redux/services/users';
import { isAdmin } from 'src/utils/user';

export type Props = { state: 'loading' | 'error' } | { state: 'ready'; users: UserDetail[]; teamVersion?: boolean };

const CustomLoadingScreen = styled(LoadingScreen)(({ theme }) => ({
  minHeight: '500px',
  backgroundColor: theme.palette.background.paper,
}));

const Wrapper = styled(Box)(() => ({
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const UsersList: React.FC<Props> = (props) => {
  const [currentUserIsAdmin, setcurrentUserIsAdmin] = React.useState(false);
  const noUsers = props.state === 'ready' && props.users.length === 0;
  const team = props.state === 'ready' && props.teamVersion ? true : false;

  const { data: currentUser } = useGetCurrentUserQuery();

  React.useEffect(() => {
    if (currentUser) {
      setcurrentUserIsAdmin(isAdmin(currentUser.item));
    }
  }, [currentUser]);

  if (noUsers) {
    return (
      <Box style={{ position: 'relative', paddingTop: 24 }}>
        <EmptyState />
      </Box>
    );
  }
  const tableheader = team ? (
    <TableHead data-cy="users-list">
      <TableRow>
        <TableCell>Member</TableCell>
        <TableCell sx={{ textAlign: 'left!important' }}>Role</TableCell>
      </TableRow>
    </TableHead>
  ) : (
    <TableHead data-cy="users-list">
      <TableRow>
        <TableCell>Name</TableCell>
        <TableCell>Status</TableCell>
        <TableCell>Role</TableCell>
        <TableCell>Last Login</TableCell>
        <TableCell>Actions</TableCell>
      </TableRow>
    </TableHead>
  );

  return (
    <Wrapper data-cy="users-list">
      {props.state === 'loading' && <CustomLoadingScreen variant="circle" />}
      <Table>
        {props.state === 'ready' && (
          <>
            {tableheader}
            <TableBody>
              {props.users.map((u) => (
                <TableRow key={u.username} hover>
                  <UserCells user={u} teamVersion={team} currentUserIsAdmin={currentUserIsAdmin} />
                </TableRow>
              ))}
            </TableBody>
          </>
        )}
      </Table>

      {props.state === 'error' && <FailureScreen>there was an error when fetching results!</FailureScreen>}
    </Wrapper>
  );
};
